import { render, staticRenderFns } from "./ColorGradient.vue?vue&type=template&id=73082f3e&"
import script from "./ColorGradient.vue?vue&type=script&lang=js&"
export * from "./ColorGradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports